export const isMobile = () => {
  let isIframe = window?.top !== window?.self
  let isMobile = /iPhone|iPod|Android/i.test(navigator.userAgent)
  return isIframe || isMobile
}

export const isAppleDevice = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}
